export const fetchLikedPosts = async () => {
  return fetch('/liked_posts', {
    method: 'GET',
    headers: {
      'Sec-Fetch-Dest': 'empty',
    },
  });
};
